"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var BaseFirebaseStorage = require("./BaseFirebaseStorage");
module.exports = /*#__PURE__*/function (_BaseFirebaseStorage) {
  (0, _inherits2["default"])(FirebaseStorageAdmin, _BaseFirebaseStorage);
  var _super = _createSuper(FirebaseStorageAdmin);
  function FirebaseStorageAdmin(bucket, firebase, pathConfig, plainToClassHook, classToPlainHook, classTransformOptions) {
    var _this;
    (0, _classCallCheck2["default"])(this, FirebaseStorageAdmin);
    _this = _super.call(this, firebase, pathConfig, "", plainToClassHook, classToPlainHook, classTransformOptions);
    _this.bucket = bucket;
    return _this;
  }
  (0, _createClass2["default"])(FirebaseStorageAdmin, [{
    key: "refFromPath",
    value: function refFromPath(fullPath) {
      return this.bucket.file(fullPath);
    }

    // this doesn't work - goolgle cloud storage doesn't allow to change name in metadata
    // async renameFile(fullPath, name){
    //     await this.setFileMetadata(fullPath, {name})
    // }
  }, {
    key: "listFiles",
    value: function listFiles(folder, delimiter) {
      return this.bucket.getFiles({
        prefix: folder,
        delimiter: delimiter
      });
    }
  }, {
    key: "file",
    value: function file(destination) {
      return this.bucket.file(destination);
    }
  }, {
    key: "downloadFile",
    value: function () {
      var _downloadFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(filePath, destination) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.file(filePath).download({
                destination: destination
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function downloadFile(_x, _x2) {
        return _downloadFile.apply(this, arguments);
      }
      return downloadFile;
    }()
  }, {
    key: "uploadFile",
    value: function uploadFile(dstPath, content) {
      this.log("StorageManager: uploadFileWithPath: dstPath = ", dstPath);
      var file = this.file(dstPath);
      return this.saveFile(file, content);
    }
  }, {
    key: "saveFile",
    value: function saveFile(file, content) {
      return file.save(content);
    }
  }, {
    key: "generateDownloadUrl",
    value: function generateDownloadUrl(file) {
      var config = {
        action: 'read',
        expires: '03-01-2500'
      };
      return file.getSignedUrl(config).then(function (urls) {
        return urls[0];
      });
    }
  }, {
    key: "copyFiles",
    value: function () {
      var _copyFiles = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(fromToPathArray) {
        var queue, _iterator, _step, fromToPath, file;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              queue = [];
              _iterator = _createForOfIteratorHelper(fromToPathArray);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  fromToPath = _step.value;
                  file = this.file(fromToPath.fromPath);
                  queue.push(file.copy(fromToPath.toPath));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context2.next = 5;
              return Promise.all(queue);
            case 5:
              return _context2.abrupt("return", _context2.sent);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function copyFiles(_x3) {
        return _copyFiles.apply(this, arguments);
      }
      return copyFiles;
    }()
  }, {
    key: "deleteFiles",
    value: function () {
      var _deleteFiles = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(filePathArray, throwOn404) {
        var queue, _iterator2, _step2, fromToPath, file;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              queue = [];
              _iterator2 = _createForOfIteratorHelper(filePathArray);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  fromToPath = _step2.value;
                  file = this.file(fromToPath);
                  queue.push(file["delete"]()["catch"](function (error) {
                    if (throwOn404 || error.code !== 404) {
                      throw error;
                    }
                  }));
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context3.next = 5;
              return Promise.all(queue);
            case 5:
              return _context3.abrupt("return", _context3.sent);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deleteFiles(_x4, _x5) {
        return _deleteFiles.apply(this, arguments);
      }
      return deleteFiles;
    }()
  }, {
    key: "deleteFilesInFolder",
    value: function deleteFilesInFolder(folder, delimiter) {
      if (!folder) {
        throw Error("deleteFiles: folder is undefined");
      }
      return this.bucket.deleteFiles({
        prefix: folder,
        delimiter: delimiter,
        force: true
      });
    }
  }, {
    key: "getFileMetadata",
    value: function () {
      var _getFileMetadata = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(fullPath) {
        var fileRef, metadataResponse;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              fileRef = this.refFromPath(fullPath);
              _context4.next = 3;
              return fileRef.getMetadata();
            case 3:
              metadataResponse = _context4.sent;
              return _context4.abrupt("return", metadataResponse[0]);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getFileMetadata(_x6) {
        return _getFileMetadata.apply(this, arguments);
      }
      return getFileMetadata;
    }()
  }, {
    key: "copyFilesInFolder",
    value: function () {
      var _copyFilesInFolder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(fromPath, toPath) {
        var _this2 = this;
        var options,
          prefixOld,
          prefixNew,
          delimiter,
          _yield$this$listFiles,
          _yield$this$listFiles2,
          files,
          promiseArray,
          _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              options = Object.assign(options, {
                recursive: true,
                destinationTransform: function destinationTransform(dst) {
                  return dst;
                }
              });
              prefixOld = fromPath;
              prefixNew = toPath;
              delimiter = options.recursive ? undefined : "/";
              _context5.next = 7;
              return this.listFiles(prefixOld, delimiter);
            case 7:
              _yield$this$listFiles = _context5.sent;
              _yield$this$listFiles2 = (0, _slicedToArray2["default"])(_yield$this$listFiles, 1);
              files = _yield$this$listFiles2[0];
              promiseArray = files.map(function (file) {
                var fileName = file.name;
                var destination = _this2.replaceAll(fileName, prefixOld, prefixNew);
                destination = options.destinationTransform(destination);
                return file.copy(destination);
              });
              _context5.next = 13;
              return Promise.all(promiseArray);
            case 13:
              return _context5.abrupt("return", _context5.sent);
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function copyFilesInFolder(_x7, _x8) {
        return _copyFilesInFolder.apply(this, arguments);
      }
      return copyFilesInFolder;
    }()
  }, {
    key: "replaceAll",
    value: function replaceAll(target, search, replacement) {
      return target.replace(new RegExp(search, 'g'), replacement);
    }
  }]);
  return FirebaseStorageAdmin;
}(BaseFirebaseStorage);